import * as THREE from 'three';
import Experience from '../Experience';
import threeTheme from '../Utils/theme.js';

export default class Light {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        const settings = this.experience.settings || {};

        // AMBIENT
        this.ambientLight = new THREE.AmbientLight();
        this.ambientLight.color = threeTheme['light-primary'];
        this.ambientLight.intensity = settings.ambient_intensity ?? 1.5;
        this.scene.add(this.ambientLight);

        // MAIN LIGHT
        const shadowResQuality = 50;
        const intensity = settings.spot_intensity ?? 3.75;
        const angle = settings.spot_angle ?? (Math.PI * .3);
        const distance = settings.spot_distance ?? 20;
        const penumbra = settings.spot_penumbra ?? 0.5;
        const decay = settings.spot_decay ?? 0;

        this.spotlight = new THREE.SpotLight('#ffffff', intensity, distance, angle, penumbra, decay);
        this.spotlight.color = threeTheme['light-secondary'];
        this.spotlight.position.set(
            settings.spot_x ?? -1,
            settings.spot_y ?? 2,
            settings.spot_z ?? 6
        );
        this.scene.add(this.spotlight);
        this.spotlight.target.position.set(0.2, 0, 0);
        this.scene.add(this.spotlight.target);
        this.spotlight.castShadow = true;
        this.spotlight.shadow.mapSize.width = 128 * shadowResQuality;
        this.spotlight.shadow.mapSize.height = 128 * shadowResQuality;
        this.spotlight.shadow.bias = -0.0005;
        this.spotlight.shadow.camera.far = 15;
        this.spotlight.shadow.camera.near = 1;
    }

    applySettings(settings) {
        const hasValue = (value) => value !== undefined && value !== null;

        if (hasValue(settings.ambient_intensity)) {
            this.ambientLight.intensity = settings.ambient_intensity;
        }
        if (hasValue(settings.ambient_color)) {
            this.ambientLight.color.set(settings.ambient_color);
        }
        if (hasValue(settings.spot_x)) this.spotlight.position.x = settings.spot_x;
        if (hasValue(settings.spot_y)) this.spotlight.position.y = settings.spot_y;
        if (hasValue(settings.spot_z)) this.spotlight.position.z = settings.spot_z;
        if (hasValue(settings.spot_intensity)) this.spotlight.intensity = settings.spot_intensity;
        if (hasValue(settings.spot_distance)) this.spotlight.distance = settings.spot_distance;
        if (hasValue(settings.spot_penumbra)) this.spotlight.penumbra = settings.spot_penumbra;
        if (hasValue(settings.spot_decay)) this.spotlight.decay = settings.spot_decay;
        if (hasValue(settings.spot_color)) this.spotlight.color.set(settings.spot_color);
    }

    destroy() {
        if (this.ambientLight) {
            this.scene.remove(this.ambientLight);
            this.ambientLight = null;
        }

        const target = this.spotlight?.target;

        if (this.spotlight) {
            if (this.spotlight.shadow?.map) {
                this.spotlight.shadow.map.dispose();
            }
            this.scene.remove(this.spotlight);
            this.spotlight = null;
        }

        if (target) {
            this.scene.remove(target);
        }
    }
}
